// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type ChevronLeft24Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const ChevronLeft24: FC<ChevronLeft24Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="24"
            height="24"
        >
            <path d="M13.657 19.2 7.76 12l5.897-7.2 1.486 1.208L10.241 12l4.902 5.992-1.486 1.208Z" />
        </svg>
    );
};

export default ChevronLeft24;
